<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-3" lang="en-GB">W<a id="_idTextAnchor004"></a>ith the Rising Sun</h1>
<p class="Verse-first" lang="en-GB">The sunlight begins to clear away the frost of the past months;</p>
<p class="Verse-main" lang="en-GB">Carrying the turning of seasons.</p>
<p class="Verse-main" lang="en-GB">The warm light clears away the shadows</p>
<p class="Verse-main" lang="en-GB">And the fuzzy little creatures begin to awaken.</p>
<p class="Verse-new" lang="en-GB">The birds begin to chirp and sing in choirs joyfully.</p>
<p class="Verse-main" lang="en-GB">Bright flowers grow and bloom,</p>
<p class="Verse-main" lang="en-GB">Encouraged by the brilliance that is the sunlight.</p>
<p class="Verse-main" lang="en-GB">They bloom in colours of pink, yellow</p>
<p class="Verse-main" lang="en-GB">Blue, white and purple;</p>
<p class="Verse-main" lang="en-GB">Spreading their joy to those who glance at them.</p>
<p class="Verse-main" lang="en-GB">The bees come flying over and dance from colourful flower</p>
<p class="Verse-main" lang="en-GB">To colourful flower,</p>
<p class="Verse-main" lang="en-GB">Doing their jobs dutifully in uniforms of black and yellow.</p>
<p class="Verse-new" lang="en-GB">Demeter cheers as her daughter Persephone creates</p>
<p class="Verse-main" lang="en-GB">The spring in which the flowers bloom.</p>
<p class="Verse-main" lang="en-GB">People marble at the warmth of the season,</p>
<p class="Verse-main" lang="en-GB">And their moods lift as they spend</p>
<p class="Verse-main" lang="en-GB">More time in the blessed outdoors; With their friends and family,</p>
<p class="Verse-main" lang="en-GB">Living in the moment.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035801855_EPUB-7.vue?2e0ba1aa